import { Link } from "react-router-dom";
import { XCircle, ArrowRight } from "lucide-react";

export default function PaymentCancelPage() {
  return (
    <div data-testid="payment-cancel-page" className="max-w-xl mx-auto px-6 py-24 text-center">
      <XCircle className="w-16 h-16 text-amber-400 mx-auto mb-6" />
      <h1 className="font-display text-2xl uppercase">Plata anulata</h1>
      <p className="text-sm text-neutral-500 mt-3">Nu s-a retras nimic. Produsele sunt in continuare in cosul tau.</p>
      <div className="flex justify-center gap-4 mt-10">
        <Link to="/cos" data-testid="back-to-cart-btn" className="inline-flex items-center gap-2 bg-[#00E5FF] text-black font-bold px-6 py-3 uppercase tracking-wider text-sm hover:bg-[#5CEEFF] transition-colors">
          Inapoi la cos <ArrowRight className="w-4 h-4" />
        </Link>
        <Link to="/magazin" className="inline-flex items-center gap-2 border border-[#00E5FF]/40 text-white font-semibold px-6 py-3 uppercase tracking-wider text-sm hover:border-[#00E5FF] transition-colors">
          Magazin
        </Link>
      </div>
    </div>
  );
}
